import React from 'react'
import { useSelector } from 'react-redux';
import { selectUserData } from '../../Redux/UserSlice';

const Wallet = () => {
    const userData = useSelector(selectUserData);

    return (
        <div>
            <div id="content">
                <div className="content-admin-main my-5">
                    <div className="admin-top-area border-0 shadow-bx d-flex flex-wrap justify-content-center m-b30 align-items-center">
                        <h2>User Wallet</h2>
                    </div>

                    {/* <div className="aon-admin-heading">
                        <h4 className="s-16 fw-700 text-022279">Edit Profile</h4>
                    </div> */}
                    <div className="card aon-card border-0 shadow">
                        <div className="card-header bg-transparent aon-card-header py-4">
                            <h4 className="s-16 fw-700 text-022279 text-capitalize">
                                <i className="fa fa-user m-2 " />
                                {userData?.username} {" "}
                                Wallet
                            </h4>
                        </div>
                        <div className="col-md-12">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12 col-sm-12 col-12">
                                        <div className="card border-0 shadow-bx p-4">
                                            <div className="card-body p-0">
                                                <p>hi</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Wallet
